import React from 'react';
import SignupPopupIcon from './Icon';
import SignupPopupMain from './Main';
import SignupPopupSuccess from './Success';
import { useGlobal } from '@/utils/useGlobal';

// 临时给members-days jp站订阅使用
export default function SignupPopup({ setVisible }: any) {
    const { useState } = useGlobal();

    // 1: popup 留邮箱 2 popup 成功success
    const [statu, setStatu] = useState(1);
    const [isRegistered, setIsRegistered] = useState(false);

    React.useEffect(() => {
        if (statu === 0) {
            setVisible(false);
        } else {
            setVisible(true);
        }
    }, [statu, setVisible]);

    return (
        <div className="signup-popup">
            <SignupPopupIcon changeStatu={setStatu} />
            {statu === 1 && <SignupPopupMain changeStatu={setStatu} callback={setIsRegistered} />}
            {statu === 2 && <SignupPopupSuccess changeStatu={setStatu} isRegistered={isRegistered} />}
        </div>
    );
}
